
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State, Toggle } from 'react-powerplug'
import FormFieldDate from './form-field-date'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfielddate"
    }}>{`FormFieldDate`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "date-field"
    }}>{`Date field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a date value. Often includes a built-in browser date picker.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => {\n        console.log(e, \'changed\')\n        setState({ value: e.target.value })\n      }}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldDate {...state} labelText="Label" id="123" onChange={e => {
          console.log(e, 'changed');
          setState({
            value: e.target.value
          });
        }} mdxType="FormFieldDate" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} labelText="Label" labelTag="Tag" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Max and min values (disabled month and year)`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      min=\"2020-04-01\"\n      max=\"2020-04-20\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} min="2020-04-01" max="2020-04-20" mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={5} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} error="Notice" labelText="Label" onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={6} __code={'<FormFieldDate labelText=\"Label\" id=\"123\" value=\"1234\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
    <FormFieldDate labelText="Label" id="123" value="1234" disabled mdxType="FormFieldDate" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "date-field-adjacent"
    }}>{`Date field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For a date value. Often includes a built-in browser date picker.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={8} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => {\n        console.log(e, \'changed\')\n        setState({ value: e.target.value })\n      }}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldDate adjacent {...state} labelText="Label" id="123" onChange={e => {
          console.log(e, 'changed');
          setState({
            value: e.target.value
          });
        }} mdxType="FormFieldDate" />}
      </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "date-field-slim"
    }}>{`Date field (slim)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For a date value. Often includes a built-in browser date picker.`}</p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={10} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      slim\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => {\n        console.log(e, \'changed\')\n        setState({ value: e.target.value })\n      }}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldDate slim {...state} labelText="Label" id="123" onChange={e => {
          console.log(e, 'changed');
          setState({
            value: e.target.value
          });
        }} mdxType="FormFieldDate" />}
      </State>
    </Playground>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <Playground __position={11} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      labelText=\"Label\"\n      labelTag=\"Tag\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} labelText="Label" labelTag="Tag" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Max and min values (disabled month and year)`}</strong></p>
    <Playground __position={12} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      min=\"2020-04-01\"\n      max=\"2020-04-20\"\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} min="2020-04-01" max="2020-04-20" slim mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={13} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} helperText="Helper text" labelText="Label" id="123" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={14} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      {...state}\n      error=\"Notice\"\n      labelText=\"Label\"\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldDate {...state} error="Notice" labelText="Label" onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldDate" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={15} __code={'<FormFieldDate labelText=\"Label\" id=\"123\" slim value=\"1234\" disabled />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <FormFieldDate labelText="Label" id="123" slim value="1234" disabled mdxType="FormFieldDate" />
    </Playground>
    <h2 {...{
      "id": "date-field-slim-adjacent"
    }}>{`Date field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For a date value. Often includes a built-in browser date picker.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <p><strong parentName="p">{`Default`}</strong></p>
    <Playground __position={16} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldDate\n      slim\n      adjacent\n      {...state}\n      labelText=\"Label\"\n      id=\"123\"\n      onChange={e => {\n        console.log(e, \'changed\')\n        setState({ value: e.target.value })\n      }}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      Toggle,
      FormFieldDate
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
  {({
          state,
          setState
        }) => <FormFieldDate slim adjacent {...state} labelText="Label" id="123" onChange={e => {
          console.log(e, 'changed');
          setState({
            value: e.target.value
          });
        }} mdxType="FormFieldDate" />}
      </State>
    </Playground>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldDate} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;